import { axiosInstance } from "./axios-instance";

export const getLegalAspectsByVerticalId = (id) => {
    const data = axiosInstance.get(
        `${process.env.CATEGORY_API_URL}/comfama/legal/api/v1/legal?verticalId=${id}`
    )
    return data
}

export const putLegalAspects = (body, header) => {
    const data = axiosInstance.put(
        `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/policy/add`,
        body,
       { 
         headers: 
          {
            'Authorization': header,
            'Content-Type': 'application/json'
          }
       }
    )
    return data
}